const state = {
  lang: "en",
};

const actions = {};

const mutations = {};

const getters = {
  subdomain() {
    const parts = window.location.host.split(".");
    //we dont have a subdomain like https://kisme.com
    if (parts.length < 3) {
      return "root";
    }
    // we have https://www.kisme.com
    else {
      // use RAFI Footer
      if (parts[0] === "wwww") {
        return "root";
      }
      // default is RAFI Footer
      else {
        return "root";
      }
    }
  },
};

export const environement = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
